<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.5 6.25V5.5C5.5 4.67157 6.17157 4 7 4H9.3787C9.7765 4 10.158 4.15803 10.4394 4.43934L11.2803 5.28033C11.4209 5.42098 11.6117 5.5 11.8106 5.5H16C16.8284 5.5 17.5 6.17157 17.5 7V11.5C17.5 12.3284 16.8284 13 16 13H14.5M2.5 14.5V8.5C2.5 7.67157 3.17157 7 4 7H6.37868C6.77651 7 7.15803 7.15803 7.43934 7.43934L8.28033 8.28033C8.42098 8.42098 8.61175 8.5 8.81065 8.5H13C13.8284 8.5 14.5 9.17155 14.5 10V14.5C14.5 15.3284 13.8284 16 13 16H4C3.17157 16 2.5 15.3284 2.5 14.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

  </svg>
</template>

<script>
export default {
  name: 'DuplicateFolderIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>
